import { Search, Filter, GitCompare } from "lucide-react";
import { useState } from "react";
import AdvancedSearchDrawer from "./AdvancedSearchDrawer";

export default function SecondaryFilters({
  disableOpen,
  open,
  onOpenChange,
  showCompareMode = false,
  onToggleCompare,
  selectedCount = 0,
}) {
  const [internalOpen, setInternalOpen] = useState(false);
  const isOpen = open ?? internalOpen;
  const setOpen = onOpenChange ?? setInternalOpen;

  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
      <label className="relative min-w-0 flex-1">
        <span className="sr-only">Search providers</span>
        <span className="pointer-events-none absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400">
          <Search size={16} aria-hidden="true" />
        </span>
        <input
          type="search"
          placeholder="Search providers"
          className="h-11 w-full rounded-xl border border-gray-200 bg-white py-2 pr-3 pl-10 text-sm outline-none placeholder:text-gray-400 focus:border-orange-400 focus:ring-2 focus:ring-orange-100"
        />
      </label>

      <div className="inline-flex h-11 min-h-11 shrink-0 overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm">
        {onToggleCompare && (
          <button
            type="button"
            aria-pressed={showCompareMode}
            onClick={onToggleCompare}
            className={`inline-flex h-full min-h-11 items-center gap-2 px-3.5 text-sm font-semibold transition-colors sm:px-4 ${
              showCompareMode
                ? "bg-emerald-600 text-white"
                : "text-gray-700 hover:bg-orange-50 hover:text-orange-800"
            }`}
          >
            <GitCompare size={16} aria-hidden="true" />
            <span>{showCompareMode ? "Done" : "Compare"}</span>
            {selectedCount > 0 && (
              <span
                className={`grid h-5 min-w-5 place-items-center rounded-full px-1 text-[10px] font-bold ${
                  showCompareMode
                    ? "bg-white text-emerald-700"
                    : "bg-orange-500 text-white"
                }`}
              >
                {selectedCount}
              </span>
            )}
          </button>
        )}

        {onToggleCompare && (
          <span className="w-px self-stretch bg-gray-200" aria-hidden="true" />
        )}

        <button
          type="button"
          aria-expanded={isOpen}
          onClick={() => !disableOpen && setOpen(true)}
          className={`inline-flex h-full min-h-11 items-center gap-2 px-3.5 text-sm font-semibold transition-colors sm:px-4 ${
            isOpen
              ? "bg-orange-500 text-white"
              : "text-gray-700 hover:bg-orange-50 hover:text-orange-800"
          }`}
        >
          <Filter size={16} aria-hidden="true" />
          <span className="hidden xl:inline">Advanced filters</span>
          <span className="xl:hidden">Filters</span>
        </button>
      </div>

      <AdvancedSearchDrawer open={isOpen} onClose={() => setOpen(false)} />
    </div>
  );
}
